export { default } from './FeesMoreIcon';
